<template>
  <div class="object-list-filter">
    <e-input v-model="filters.query" label="Поиск" class="object-list-filter__input">
      <template #append-inner>
        <e-icon name="search" :size="20" />
      </template>
    </e-input>

    <e-select
      v-if="$vuetify.display.lgAndUp"
      v-model="filters.type"
      :items="types"
      item-title="type"
      item-value="type"
      label="Тип"
      class="object-list-filter__input"
      clearable
    />

    <filters-dialog v-else v-model="filters" :default-filters="defaultFilters">
      <template #activator>
        <e-btn variant="tonal" class="books__filters-btn" icon> <e-icon name="options" /></e-btn>
      </template>

      <template #default="{ items }">
        <div>
          <e-input v-model="items.query" label="Поиск" class="mb-4">
            <template #append-inner>
              <e-icon name="search" :size="20" />
            </template>
          </e-input>
          <e-select v-model="items.type" :items="types" item-title="type" item-value="type" label="Тип" clearable />
        </div>
      </template>
    </filters-dialog>
  </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core';
import type { Dictionary } from '@/core/types/gengeric';
import FiltersDialog from '@/core/components/common/FiltersDialog.vue';
import { EBtn, EIcon, EInput, ESelect } from '@/core/components/ui';
import { defaultFilters } from '@/parts/objects/utils/consts';

const props = defineProps<{
  modelValue: {
    query: string;
    type: string | null;
  };
  types: Dictionary<unknown>[];
}>();

const filters = useVModel(props, 'modelValue');
</script>

<style scoped lang="scss">
.object-list-filter {
  display: flex;
  gap: $gap-4;

  width: 100%;

  &__input {
    width: 100%;
    max-width: 280px;

    @include sm-and-down {
      max-width: 100%;
    }
  }
}
</style>
